import { useCallback, useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { sendSMSAction } from '../../actions/smsActions'
import { loginAction } from '../../actions/userActions'
import { aifianDynamicLink } from '../../libs/constants'
import { remove886, toSegmentedPhoneNumber } from '../../libs/utils'
import {
  onlyAllowMemberSelector,
  shortURLSelector,
} from '../../reducers/itemEntryReducer'
import { isFetchingSelector } from '../../reducers/uiReducer'

import { authenticatedSelector } from '../../reducers/userReducer'
import NavBar from '../common/NavBar'
import { ga4Event } from '../libs/ga4'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'
import { memberOrGuestIdSelector } from '../libs/selectors'
import BuyerLoginForm from './BuyerLoginForm'
import ConfirmSMSForm from './ConfirmSMSForm'

function BuyerLogin(props) {
  const {
    authenticated,
    sentPhone,
    memberPhone,
    onlyAllowMember,
    sendSMS,
    userId,
    toPayment,
    toConfirmUser,
    login,
    validateUsername,
    shortURL,
  } = props

  const showMemberLoginFields = !!memberPhone || onlyAllowMember
  const isFetching = useSelector(state => isFetchingSelector(state.ui))

  useEffect(() => {
    if (userId) {
      if (authenticated) {
        toPayment()
      } else {
        toConfirmUser()
      }
    }
  }, [authenticated, userId, toPayment, toConfirmUser])

  const [loginError, setLoginError] = useState(null)

  const buyerLoginCallback = useCallback(
    data => {
      const { username } = data
      const usernameError = validateUsername(username)
      if (!usernameError) {
        if (showMemberLoginFields) {
          ga4Event(
            onlyAllowMember
              ? 'slash_login_notall_total'
              : 'slash_login_all_user',
          )
          login(data, setLoginError)
        } else {
          sendSMS(username)
        }
      } else {
        alert(usernameError)
        setLoginError({ username: usernameError })
      }
    },
    [
      showMemberLoginFields,
      login,
      validateUsername,
      sendSMS,
      setLoginError,
      onlyAllowMember,
    ],
  )

  useGA4Pageview('slash_login_all_enter', !onlyAllowMember)
  useGA4Pageview('slash_login_notall_enter', onlyAllowMember)

  return (
    <>
      <NavBar />
      <div className="container mt-navbarSpacing">
        <div>
          <p className="babu-text-subtitle text-text600 pt-l mb-xxs">
            {sentPhone ? '輸入驗證碼' : '使用 aifian 輕鬆付款'}
          </p>
          <p className="babu-text-paragraph text-text600 mb-l">
            {sentPhone ? (
              `已寄送簡訊到 ${toSegmentedPhoneNumber(remove886(sentPhone))}`
            ) : showMemberLoginFields ? (
              <>
                還不是用戶？
                <a
                  className="babu-text-paragraph text-text600 underline cursor-pointer text"
                  href={aifianDynamicLink}
                  onClick={e => {
                    e.preventDefault()
                    ga4Event('slash_login_signup', 'click')
                    setTimeout(() => {
                      window.location.href = aifianDynamicLink
                    }, 10)
                  }}
                  target="_blank"
                  rel="noopener noreferrer">
                  立即註冊
                </a>
              </>
            ) : (
              '輸入手機號碼登入'
            )}
          </p>
        </div>
        {sentPhone ? (
          <ConfirmSMSForm
            phone={sentPhone}
            sendSMS={sendSMS}
            isLoading={isFetching}
          />
        ) : (
          <BuyerLoginForm
            memberPhone={memberPhone}
            showMemberLoginFields={showMemberLoginFields}
            login={buyerLoginCallback}
            loginError={loginError}
            shortURL={shortURL}
            isLoading={isFetching}
          />
        )}
      </div>
    </>
  )
}

export default connect(
  state => ({
    authenticated: authenticatedSelector(state.user),
    sentPhone: state.sms.sentPhone,
    memberPhone: state.sms.memberPhone,
    onlyAllowMember: onlyAllowMemberSelector(state.itemEntry),
    userId: memberOrGuestIdSelector(state.user, state.sms),
    isVendor: !!state.vendor.vendorInfo,
    shortURL: shortURLSelector(state.itemEntry),
  }),
  dispatch => ({
    login(data, onError) {
      dispatch(
        loginAction({
          ...data,
          onError,
          isBuyer: true,
        }),
      )
    },
    sendSMS(phone) {
      dispatch(sendSMSAction(phone))
    },
  }),
)(BuyerLogin)
